const  projectsLaravel = [
    {
       proTitle: "Laravel projects", 
       projectProps: [
            {
                title: "Rss feed reader",
                img: "./img_projects/laravel/project1.png",
                desc: "Permette di ottenere le notizie dai principlai produttori di news online.",
                long_desc: "Questo progetto permette di ricevere notizie tramite il file RSS di google news, per utilizzare le funzionalità, vai sulla notizia di tuo interesse, cliccala per selezionarla, quindi premi il tasto 'Alt' per far apparire il pulsante che punta al collegamento della notizia notizia.",
                topics: "PHP, OOP, MySQL, Javascript, HTML/CSS, XML",
                location_url: "./web_app/projects/LaravelJS/Laravel-fundamentals/index.html",
                source_code: false
            },
            {
                title: "User Post",
                img: "./img_projects/Laravel/project2.png",
                desc: "Post application:  creare, editare o rimuovere i propi post.",
                long_desc: "Il progetto è incentrato sulle connessioni al database, in particolare con relazioni tra tabelle di tipo uno (user) a molti (Posts), l'applicazione si presenta con una home page dove tramite una barra di navigazione permette di selezionare il percorso del servizio, il l'utente non loggato può navigare in tutte le parti del sito tranne la sezione: \"Post\", in quanto per accedere a quest'area l'utente deve essere autenticato, se l'utente non è autorizzato e tenta di accedere a questa sezione è invitato ad autenticarsi .",
                topics: "PHP, OOP, ORM Eloquent, Auth",
                location_url: "https://github.com/pippo-github/laravel-user-post",
                source_code: false
            },
        ]
    }
]

export {projectsLaravel}
